function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 19"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 18"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 3",
  y: 3,
  width: 40,
  height: 40,
  rx: 20,
  fill: "#39FF14"
})), /*#__PURE__*/React.createElement("rect", {
  id: "svg-button",
  x: 2.5,
  y: 0.5,
  width: 39,
  height: 39,
  rx: 19.5,
  fill: "#C58FFF",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M34.6022 12.3724C33.6975 12.7733 32.7255 13.0441 31.7038 13.1666C32.758 12.5358 33.5468 11.5429 33.9228 10.3733C32.9323 10.9616 31.8483 11.3757 30.7178 11.5977C29.9576 10.786 28.9507 10.248 27.8533 10.0672C26.756 9.88638 25.6297 10.0729 24.6493 10.5978C23.6689 11.1228 22.8892 11.9567 22.4313 12.9701C21.9734 13.9836 21.8628 15.1199 22.1169 16.2026C20.1099 16.1018 18.1465 15.5802 16.3542 14.6715C14.5618 13.7628 12.9806 12.4874 11.713 10.928C11.2796 11.6757 11.0304 12.5425 11.0304 13.4656C11.0299 14.2967 11.2346 15.115 11.6262 15.848C12.0178 16.581 12.5843 17.2059 13.2755 17.6675C12.474 17.642 11.6901 17.4254 10.9892 17.0358V17.1008C10.9892 18.2664 11.3923 19.3961 12.1304 20.2982C12.8684 21.2004 13.8958 21.8194 15.0383 22.0503C14.2948 22.2515 13.5153 22.2811 12.7586 22.137C13.081 23.1399 13.7089 24.0169 14.5544 24.6452C15.3999 25.2735 16.4208 25.6217 17.4741 25.641C15.6861 27.0446 13.4779 27.806 11.2049 27.8026C10.8022 27.8027 10.3999 27.7792 10 27.7322C12.3073 29.2157 14.9932 30.003 17.7363 30C27.0219 30 32.0982 22.3092 32.0982 15.6391C32.0982 15.4224 32.0928 15.2036 32.083 14.9869C33.0704 14.2728 33.9227 13.3886 34.6 12.3756L34.6022 12.3724Z",
  fill: "#39FF14",
  stroke: "black",
  strokeWidth: 0.5
}));

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.97f229ab.svg";
export { ForwardRef as ReactComponent };